export enum TutorialId {
  Basics = "BASICS",
  Combat = "COMBAT",
  JobPriorities = "JOB_PRIORITIES",
  Morale = "MORALE",
  Residence = "RESIDENCE",
  Rotate = "ROTATE",
}
